import { ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DOC_VERSIONING_FEATURE_CODE } from 'src/app/features/plans/models/entitlement.model';
import { PlanFeatureService } from 'src/app/features/plans/services/plan-feature.service';
import { DocumentService } from 'src/app/services/document.service';
import { DriveContextMenuCoordinator } from './drive-context-menu.coordinator';
import { DriveItem } from './drive-viewer.models';
import { DriveMoveState, DriveVersionState } from './drive-viewer.state';

export class DriveVersionHistoryCoordinator {
  constructor(
    private readonly state: DriveVersionState,
    private readonly move: DriveMoveState,
    private readonly contextMenu: DriveContextMenuCoordinator,
    private readonly documents: DocumentService,
    private readonly dialog: MatDialog,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly planFeatures: PlanFeatureService | undefined,
    private readonly translate: (key: string) => string
  ) {}

  initializeFeature(): void {
    this.planFeatures?.hasFeature(DOC_VERSIONING_FEATURE_CODE).subscribe((enabled) => {
      this.state.docVersioningEnabled = enabled;
    });
  }

  showBadge(item: DriveItem): boolean {
    return this.state.docVersioningEnabled
      && item.type !== 'folder'
      && !!item.documentId
      && !!this.state.versionBadges[item.documentId];
  }

  openFromContext(): void {
    const item = this.move.contextMenuItem;
    this.contextMenu.close();
    if (!this.state.docVersioningEnabled || !item || item.type === 'folder' || !item.documentId) {
      return;
    }
    const documentId = String(item.documentId);
    this.state.versionHistoryItem = item;
    this.state.versionHistory = [];
    this.state.versionHistoryError = '';
    this.state.versionHistoryLoading = true;
    this.documents.getDocumentVersions(documentId).subscribe({
      next: (versions) => {
        this.state.versionHistory = versions || [];
        const active = this.state.versionHistory.find((version) => version.isActive)
          || this.state.versionHistory[0];
        if (active) this.state.versionBadges[documentId] = active.versionNo;
        this.state.versionHistoryLoading = false;
        this.changeDetector.detectChanges();
      },
      error: () => {
        this.state.versionHistoryError = this.translate('documents.versions.error');
        this.state.versionHistoryLoading = false;
        this.changeDetector.detectChanges();
      }
    });
    if (!this.state.versionsDialogTpl) return;
    this.state.versionsDialogRef = this.dialog.open(this.state.versionsDialogTpl, {
      width: '520px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      panelClass: 'drive-document-dialog-panel'
    });
    this.state.versionsDialogRef.afterClosed().subscribe(() => {
      this.state.versionsDialogRef = undefined;
      this.state.versionHistoryItem = undefined;
    });
  }
}
